import React from 'react';
import icon from '../Icons/svgs';
const { HtmlIcon, ImageIcon, JsonIcon, MarkdownIcon, Mp3Icon, Mp4Icon, AIIcon, ScoreSuccess, OtherIcon, HoverShuru, PdfIcon, PPTIcon, PSIcon, TxtIcon, WordIcon, XlsIcon, ImportDocIcon, DownloadFailIcon, UploadErrorIcon, DownloadIcon, UploadIcon, MoreIcon, ZipIcon, SaveIcon, NextIcon, PreviousIcon, OpenIcon, CloseIcon, DoUploadIcon, DoDownloadIcon, PrivateDiskIcon, Search, PublickDisk, RecentlyIcon, Share, DiskUpload, ArrowRight, ArrowLeft, Folder, RecycleBin, Info, AddFolder, CloseCircle, BoldUploadIcon, BoldDownloadIcon, UpTriangle, DownTriangle, CreateIcon, LxXlsIcon, LxDocIcon, LxUnitableIcon, BackArrowIcon, BackIcon, SavedIcon, HistoryIcon, ExportIcon, MoveToIcon, HomePageIcon, SharePageIcon, ShrinkIcon, OriginalIcon, RotateLeft, AmplificationIcon, RenameFile, DiskMoveFolder, SendEmailSvg, ExternalLink, ExternalAccount, ExternalVisit, ExternalDownload, Browser, File, IconFolder, FilterTriangleDown, Camera, Account, Expand, Collapse, Inbox, RecoverIcon, InfoTips, StarGray, StarGold, Brush, TemplateIcon, Alarm, AddFileIcon, EmlIcon, TaskIcon, Conference, AddMember, Mark, MailExchange, Question, AllipseGroup, Discuss, GreenDiscuss, Descend, Ascend, Chat, MaxEditor, MinEditor, TabDropdown, WarnYellow, CrmClient, HintClient, ResetSearch, ArrowUp, ArrowDown, Jiantouyidong, TongyongCuowutishiXian, TongyongQingchu, TongyongYouxiang2, TongyongJiantouShang, TongyongZuixiaohua2, TongyongCaogao, TongyongShezhi, TongyongDizhibu, TongyongXiansuo, TongyongXiaoxi, TongyongBaocun, TongyongFangda, TongyongFanyi, TongyongShuomingMian, TongyongDingyuechenggong, TongyongRili3, TongyongTianjia, TongyongBiaoqianMian, TongyongShift, TongyongKuaijie, TongyongDianzanMianxing, BianjiJuhe, TongyongJiantouYou1, TongyongRili2, TongyongDaochu, TongyongDingyuerili, TongyongFuzhi, TongyongBiaoqing, TongyongJiantouZuo1, TongyongDizhi, TongyongXuanzhuan, JichuJiagou, Schedule, TongyongYouxiang4, TongyongShanchuMian1, TongyongChanpinguanli, TongyongJiantouShang1, TongyongXiaoxi3Xian1, TongyongXingxingMian, TongyongShouji, TongyongLianjie, TongyongRenwu1, TongyongBianjiMian, TongyongYouxiang5Xian, TongyongQiye, TongyongYouxiang6, TongyongDulichuangkou, TongyongShezhi2Mian, bianjiHuifu, TongyongShaixuan, TongyongYuyin, TongyongShuangjiantouShang, TongyongRenyuan10, TongyongPaizhao, TongyongBiaoqian2Xian, TongyongYiwenMian, TongyongYouxian, TongyongDiqiu, TongyongHoutai, TongyongGongju, BianjiHongqiXian, TongyongRenyuan11, TongyongFasong, TongyongZuixiaohua, TongyongRenwu, TongyongShijianXian, TongyongOcr, TongyongShuru, TongyongXiaoxi3Xian, TongyongShoujianxiang, TongyongZhankaiXian, TongyongShangchuan, TongyongWenjianjia, TongyongZuidahua, TongyongKuaijiejian, TongyongZuidahua2, TongyongQueren, TongyongSuoGuan, TongyongShangchuan2Xian, TongyongFaqizhe, TongyongQuxiaozhiding, TongyongTianjiaXian, TongyongRili, TongyongCommand, TongyongChenggongXian, TongyongGengduo2, TongyongGuanbiXian, TongyongWangluoyichangXian, TongyongRenyuan9, TongyongShanchuXian, TongyongGaojisousuo, TongyongBofang, TongyongShuju, TongyongRenyuan8, TongyongJianshao, TongyongChanpin2, TongyongXunhuan, TongyongJingshi, TongyongZhankaiShang, TongyongTupian, TongyongZhankaiYou, TongyongRenyuan5, TongyongBiaoqianXian, TongyongLishijilu, TongyongWendang, Jiantoujinyong, TongyongRenyuan4, TongyongShijianMianxing, TongyongFenxiang, TongyongXunzhang, TongyongShuangjiantouZuo, TongyongShouqiXian, TongyongYuedu, TongyongFasongMianxing, TongyongCuowutishiMian, TongyongRenyuan6, TongyongShuaxin, TongyongZhankaiXia, BianjiZhuanfa, TongyongMokuai, TongyongYingwen, TongyongRenyuan7, TongyongLianglan, TongyongDaoru, TongyongShuju2, Shuruguangbiao, TongyongShuomingXian, TongyongBangzhufankui, TongyongXiaoxi2Mian1, TongyongXinjianwenjianjia, TongyongDiannao, TongyongRenyuan3, TongyongShujutongji, TongyongYouxiang5Mian, TongyongShezhi2Xian, Subscribe, TongyongRenyuan2, TongyongZhaiyao, TongyongWhatsapp, TongyongYiwen, TongyongXianshi, TongyongZhongwen, TongyongJiantouZuo, TongyongYouxiang, TongyongJilu, TongyongZhiding, TongyongGengduo, TongyongKongxian, TongyongRenyuan1, TongyongXingxingXian, TongyongWendang3, TongyongMoban, TongyongJiazai, TongyongJiantouXia1, TongyongYidong1, TongyongSousuo, TongyongShanchu, TongyongDizhibu2, TongyongShuangjiantouYou, TongyongXiaoxi2Mian, TongyongZijin, TongyongPaixu, TongyongDelete, TongyongYouxiangMian, TongyongZhongmingming, TongyongGonggao, TongyongZhankaiZuo, TongyongDianzanXianxing, TongyongTixing, TongyongQuxiaotixing, TongyongShuangjiantouXia, bianjiHongqiMian, TongyongYun, TongyongXiazai2Mian, TongyongQuanbu, TongyongWangluoyichangMian, TongyongYincang, TongyongJiantouXia, TongyongDaoru1, TongyongFuxuankuang, TongyongDaochu1, TongyongShangchuan2Xian1, TongyongShanchuMian, TongyongChehui, TongyongJianshaoXian, TongyongYidong, TongyongLiebiao, TongyongZanting, TongyongEnter, TongyongSuoKai, BianjiHongqi2Xian, TongyongXiazaiMian, TongyongSanlan, TongyongYidu, TongyongFanhuichuangkou, TongyongShangchuan2Mian, TongyongXiazai, TongyongHuiyuan, TongyongJiantouYou, TongyongFujian, TongyongChenggongMian, TongyongWenjianjia2, TongyongShouqi, TongyongHuifuquanbu, MailComment, ContentAssistantRight, ContentAssistantLeft, ContactLeft, ContactRight, Comment3, ActivityBtn, PriceList, Product, Signature, Template, MarketPage, Mannual, } = icon;
export const iconMap = {
    activityBtn: ActivityBtn,
    priceList: PriceList,
    mannual: Mannual,
    product: Product,
    signature: Signature,
    template2: Template,
    marketPage: MarketPage,
    mailComment: MailComment,
    comment3: Comment3,
    maxEditor: MaxEditor,
    minEditor: MinEditor,
    ContentAssistantLeft: ContentAssistantLeft,
    ContentAssistantRight: ContentAssistantRight,
    allipseGroup: AllipseGroup,
    add: AddMember,
    taskMail: TaskIcon,
    conference: Conference,
    externalLink: ExternalLink,
    sendMail: SendEmailSvg,
    externalAccount: ExternalAccount,
    externalVisit: ExternalVisit,
    externalDownload: ExternalDownload,
    closeCircle: CloseCircle,
    diskUpload: DiskUpload,
    addFolder: AddFolder,
    arrowLeft: ArrowLeft,
    arrowRight: ArrowRight,
    folder: Folder,
    dir: Folder,
    recycleBin: RecycleBin,
    infoTips: InfoTips,
    renameFile: RenameFile,
    info: Info,
    downloadFail: DownloadFailIcon,
    share: Share,
    publicDisk: PublickDisk,
    search: Search,
    privateDisk: PrivateDiskIcon,
    recently: RecentlyIcon,
    homepage: HomePageIcon,
    sharePage: SharePageIcon,
    zip: ZipIcon,
    ZIP: ZipIcon,
    rar: ZipIcon,
    RAR: ZipIcon,
    html: HtmlIcon,
    HTML: HtmlIcon,
    jpg: ImageIcon,
    JPG: ImageIcon,
    jpeg: ImageIcon,
    JPEG: ImageIcon,
    png: ImageIcon,
    PNG: ImageIcon,
    svg: ImageIcon,
    SVG: ImageIcon,
    gif: ImageIcon,
    GIF: ImageIcon,
    json: JsonIcon,
    JSON: JsonIcon,
    md: MarkdownIcon,
    MD: MarkdownIcon,
    mp3: Mp3Icon,
    MP3: Mp3Icon,
    wav: Mp3Icon,
    WAV: Mp3Icon,
    mp4: Mp4Icon,
    MP4: Mp4Icon,
    mov: Mp4Icon,
    MOV: Mp4Icon,
    scoreSuccess: ScoreSuccess,
    AIIcon: AIIcon,
    pdf: PdfIcon,
    PDF: PdfIcon,
    ppt: PPTIcon,
    PPT: PPTIcon,
    pptx: PPTIcon,
    PPTX: PPTIcon,
    ps: PSIcon,
    PS: PSIcon,
    txt: TxtIcon,
    TXT: TxtIcon,
    word: WordIcon,
    WORD: WordIcon,
    doc: WordIcon,
    DOC: WordIcon,
    docx: WordIcon,
    DOCX: WordIcon,
    xls: XlsIcon,
    XLS: XlsIcon,
    xlsx: XlsIcon,
    XLSX: XlsIcon,
    hoverShuru: HoverShuru,
    importDoc: ImportDocIcon,
    other: OtherIcon,
    error: UploadErrorIcon,
    download: DownloadIcon,
    upload: UploadIcon,
    more: MoreIcon,
    save: SaveIcon,
    next: NextIcon,
    previous: PreviousIcon,
    open: OpenIcon,
    close: CloseIcon,
    doUpload: DoUploadIcon,
    doDownload: DoDownloadIcon,
    boldUpload: BoldUploadIcon,
    boldDownload: BoldDownloadIcon,
    upTriangle: UpTriangle,
    downTriangle: DownTriangle,
    create: CreateIcon,
    lxxls: LxXlsIcon,
    lxdoc: LxDocIcon,
    lxunitable: LxUnitableIcon,
    backArrow: BackArrowIcon,
    backIcon: BackIcon,
    saved: SavedIcon,
    history: HistoryIcon,
    export: ExportIcon,
    moveTo: MoveToIcon,
    shrink: ShrinkIcon,
    original: OriginalIcon,
    rotateLeft: RotateLeft,
    amplification: AmplificationIcon,
    diskMoveFolder: DiskMoveFolder,
    browser: Browser,
    file: File,
    iconFolder: IconFolder,
    filterTriangleDown: FilterTriangleDown,
    account: Account,
    camera: Camera,
    expand: Expand,
    collapse: Collapse,
    inbox: Inbox,
    recover: RecoverIcon,
    starGray: StarGray,
    starGold: StarGold,
    brush: Brush,
    template: TemplateIcon,
    alarm: Alarm,
    addFile: AddFileIcon,
    eml: EmlIcon,
    mark: Mark,
    mailExchange: MailExchange,
    question: Question,
    discuss: Discuss,
    greenDiscuss: GreenDiscuss,
    descend: Descend,
    ascend: Ascend,
    chat: Chat,
    tabDropdown: TabDropdown,
    warnYellow: WarnYellow,
    resetSearch: ResetSearch,
    arrowUp: ArrowUp,
    arrowDown: ArrowDown,
    crmClient: CrmClient,
    hintClient: HintClient,
    jiantouyidong: Jiantouyidong,
    tongyong_cuowutishi_xian: TongyongCuowutishiXian,
    tongyong_qingchu: TongyongQingchu,
    tongyong_youxiang2: TongyongYouxiang2,
    tongyong_jiantou_shang: TongyongJiantouShang,
    tongyong_zuixiaohua2: TongyongZuixiaohua2,
    tongyong_caogao: TongyongCaogao,
    tongyong_shezhi: TongyongShezhi,
    tongyong_dizhibu: TongyongDizhibu,
    tongyong_xiansuo: TongyongXiansuo,
    tongyong_xiaoxi: TongyongXiaoxi,
    tongyong_baocun: TongyongBaocun,
    tongyong_fangda: TongyongFangda,
    tongyong_fanyi: TongyongFanyi,
    tongyong_shuoming_mian: TongyongShuomingMian,
    tongyong_dingyuechenggong: TongyongDingyuechenggong,
    tongyong_rili3: TongyongRili3,
    tongyong_tianjia: TongyongTianjia,
    tongyong_biaoqian_mian: TongyongBiaoqianMian,
    tongyong_shift: TongyongShift,
    tongyong_kuaijie: TongyongKuaijie,
    tongyong_dianzan_mianxing: TongyongDianzanMianxing,
    bianji_juhe: BianjiJuhe,
    tongyong_jiantou_you1: TongyongJiantouYou1,
    tongyong_rili2: TongyongRili2,
    tongyong_daochu: TongyongDaochu,
    tongyong_dingyuerili: TongyongDingyuerili,
    tongyong_fuzhi: TongyongFuzhi,
    tongyong_biaoqing: TongyongBiaoqing,
    tongyong_jiantou_zuo1: TongyongJiantouZuo1,
    tongyong_dizhi: TongyongDizhi,
    tongyong_xuanzhuan: TongyongXuanzhuan,
    jichu_jiagou: JichuJiagou,
    schedule: Schedule,
    tongyong_youxiang4: TongyongYouxiang4,
    tongyong_shanchu_mian1: TongyongShanchuMian1,
    tongyong_chanpinguanli: TongyongChanpinguanli,
    tongyong_jiantou_shang1: TongyongJiantouShang1,
    tongyong_xiaoxi3_xian1: TongyongXiaoxi3Xian1,
    tongyong_xingxing_mian: TongyongXingxingMian,
    tongyong_shouji: TongyongShouji,
    tongyong_lianjie: TongyongLianjie,
    tongyong_renwu1: TongyongRenwu1,
    tongyong_bianji_mian: TongyongBianjiMian,
    tongyong_youxiang5_xian: TongyongYouxiang5Xian,
    tongyong_qiye: TongyongQiye,
    tongyong_youxiang6: TongyongYouxiang6,
    tongyong_dulichuangkou: TongyongDulichuangkou,
    tongyong_shezhi2_mian: TongyongShezhi2Mian,
    bianji_huifu: bianjiHuifu,
    tongyong_shaixuan: TongyongShaixuan,
    tongyong_yuyin: TongyongYuyin,
    tongyong_shuangjiantou_shang: TongyongShuangjiantouShang,
    tongyong_renyuan10: TongyongRenyuan10,
    tongyong_paizhao: TongyongPaizhao,
    tongyong_biaoqian2_xian: TongyongBiaoqian2Xian,
    tongyong_yiwen_mian: TongyongYiwenMian,
    tongyong_youxian: TongyongYouxian,
    tongyong_diqiu: TongyongDiqiu,
    tongyong_houtai: TongyongHoutai,
    tongyong_gongju: TongyongGongju,
    bianji_hongqi_xian: BianjiHongqiXian,
    tongyong_renyuan11: TongyongRenyuan11,
    tongyong_fasong: TongyongFasong,
    tongyong_zuixiaohua: TongyongZuixiaohua,
    tongyong_renwu: TongyongRenwu,
    tongyong_shijian_xian: TongyongShijianXian,
    tongyong_ocr: TongyongOcr,
    tongyong_shuru: TongyongShuru,
    tongyong_xiaoxi3_xian: TongyongXiaoxi3Xian,
    tongyong_shoujianxiang: TongyongShoujianxiang,
    tongyong_zhankai_xian: TongyongZhankaiXian,
    tongyong_shangchuan: TongyongShangchuan,
    tongyong_wenjianjia: TongyongWenjianjia,
    tongyong_zuidahua: TongyongZuidahua,
    tongyong_kuaijiejian: TongyongKuaijiejian,
    tongyong_zuidahua2: TongyongZuidahua2,
    tongyong_queren: TongyongQueren,
    tongyong_suo_guan: TongyongSuoGuan,
    tongyong_shangchuan2_xian: TongyongShangchuan2Xian,
    tongyong_faqizhe: TongyongFaqizhe,
    tongyong_quxiaozhiding: TongyongQuxiaozhiding,
    tongyong_tianjia_xian: TongyongTianjiaXian,
    tongyong_rili: TongyongRili,
    tongyong_command: TongyongCommand,
    tongyong_chenggong_xian: TongyongChenggongXian,
    tongyong_gengduo2: TongyongGengduo2,
    tongyong_guanbi_xian: TongyongGuanbiXian,
    tongyong_wangluoyichang_xian: TongyongWangluoyichangXian,
    tongyong_renyuan9: TongyongRenyuan9,
    tongyong_shanchu_xian: TongyongShanchuXian,
    tongyong_gaojisousuo: TongyongGaojisousuo,
    tongyong_bofang: TongyongBofang,
    tongyong_shuju: TongyongShuju,
    tongyong_renyuan8: TongyongRenyuan8,
    tongyong_jianshao: TongyongJianshao,
    tongyong_chanpin2: TongyongChanpin2,
    tongyong_xunhuan: TongyongXunhuan,
    tongyong_jingshi: TongyongJingshi,
    tongyong_zhankai_shang: TongyongZhankaiShang,
    tongyong_tupian: TongyongTupian,
    tongyong_zhankai_you: TongyongZhankaiYou,
    tongyong_renyuan5: TongyongRenyuan5,
    tongyong_biaoqian_xian: TongyongBiaoqianXian,
    tongyong_lishijilu: TongyongLishijilu,
    tongyong_wendang: TongyongWendang,
    jiantoujinyong: Jiantoujinyong,
    tongyong_renyuan4: TongyongRenyuan4,
    tongyong_shijian_mianxing: TongyongShijianMianxing,
    tongyong_fenxiang: TongyongFenxiang,
    tongyong_xunzhang: TongyongXunzhang,
    tongyong_shuangjiantou_zuo: TongyongShuangjiantouZuo,
    tongyong_shouqi_xian: TongyongShouqiXian,
    tongyong_yuedu: TongyongYuedu,
    tongyong_fasong_mianxing: TongyongFasongMianxing,
    tongyong_cuowutishi_mian: TongyongCuowutishiMian,
    tongyong_renyuan6: TongyongRenyuan6,
    tongyong_shuaxin: TongyongShuaxin,
    tongyong_zhankai_xia: TongyongZhankaiXia,
    bianji_zhuanfa: BianjiZhuanfa,
    tongyong_mokuai: TongyongMokuai,
    tongyong_yingwen: TongyongYingwen,
    tongyong_renyuan7: TongyongRenyuan7,
    tongyong_lianglan: TongyongLianglan,
    tongyong_daoru: TongyongDaoru,
    tongyong_shuju2: TongyongShuju2,
    shuruguangbiao: Shuruguangbiao,
    tongyong_shuoming_xian: TongyongShuomingXian,
    tongyong_bangzhufankui: TongyongBangzhufankui,
    tongyong_xiaoxi2_mian1: TongyongXiaoxi2Mian1,
    tongyong_xinjianwenjianjia: TongyongXinjianwenjianjia,
    tongyong_diannao: TongyongDiannao,
    tongyong_renyuan3: TongyongRenyuan3,
    tongyong_shujutongji: TongyongShujutongji,
    tongyong_youxiang5_mian: TongyongYouxiang5Mian,
    tongyong_shezhi2_xian: TongyongShezhi2Xian,
    subscribe: Subscribe,
    tongyong_renyuan2: TongyongRenyuan2,
    tongyong_zhaiyao: TongyongZhaiyao,
    tongyong_whatsapp: TongyongWhatsapp,
    tongyong_yiwen: TongyongYiwen,
    tongyong_xianshi: TongyongXianshi,
    tongyong_zhongwen: TongyongZhongwen,
    tongyong_jiantou_zuo: TongyongJiantouZuo,
    tongyong_youxiang: TongyongYouxiang,
    tongyong_jilu: TongyongJilu,
    tongyong_zhiding: TongyongZhiding,
    tongyong_gengduo: TongyongGengduo,
    tongyong_kongxian: TongyongKongxian,
    tongyong_renyuan1: TongyongRenyuan1,
    tongyong_xingxing_xian: TongyongXingxingXian,
    tongyong_wendang3: TongyongWendang3,
    tongyong_moban: TongyongMoban,
    tongyong_jiazai: TongyongJiazai,
    tongyong_jiantou_xia1: TongyongJiantouXia1,
    tongyong_yidong1: TongyongYidong1,
    tongyong_sousuo: TongyongSousuo,
    tongyong_shanchu: TongyongShanchu,
    tongyong_dizhibu2: TongyongDizhibu2,
    tongyong_shuangjiantou_you: TongyongShuangjiantouYou,
    tongyong_xiaoxi2_mian: TongyongXiaoxi2Mian,
    tongyong_zijin: TongyongZijin,
    tongyong_paixu: TongyongPaixu,
    tongyong_delete: TongyongDelete,
    tongyong_youxiang_mian: TongyongYouxiangMian,
    tongyong_zhongmingming: TongyongZhongmingming,
    tongyong_gonggao: TongyongGonggao,
    tongyong_zhankai_zuo: TongyongZhankaiZuo,
    tongyong_dianzan_xianxing: TongyongDianzanXianxing,
    tongyong_tixing: TongyongTixing,
    tongyong_quxiaotixing: TongyongQuxiaotixing,
    tongyong_shuangjiantou_xia: TongyongShuangjiantouXia,
    bianji_hongqi_mian: bianjiHongqiMian,
    tongyong_yun: TongyongYun,
    tongyong_xiazai2_mian: TongyongXiazai2Mian,
    tongyong_quanbu: TongyongQuanbu,
    tongyong_wangluoyichang_mian: TongyongWangluoyichangMian,
    tongyong_yincang: TongyongYincang,
    tongyong_jiantou_xia: TongyongJiantouXia,
    tongyong_daoru1: TongyongDaoru1,
    tongyong_fuxuankuang: TongyongFuxuankuang,
    tongyong_daochu1: TongyongDaochu1,
    tongyong_shangchuan2_xian1: TongyongShangchuan2Xian1,
    tongyong_shanchu_mian: TongyongShanchuMian,
    tongyong_chehui: TongyongChehui,
    tongyong_jianshao_xian: TongyongJianshaoXian,
    tongyong_yidong: TongyongYidong,
    tongyong_liebiao: TongyongLiebiao,
    tongyong_zanting: TongyongZanting,
    tongyong_enter: TongyongEnter,
    tongyong_suo_kai: TongyongSuoKai,
    bianji_hongqi2_xian: BianjiHongqi2Xian,
    tongyong_xiazai_mian: TongyongXiazaiMian,
    tongyong_sanlan: TongyongSanlan,
    tongyong_yidu: TongyongYidu,
    tongyong_fanhuichuangkou: TongyongFanhuichuangkou,
    tongyong_shangchuan2_mian: TongyongShangchuan2Mian,
    tongyong_xiazai: TongyongXiazai,
    tongyong_huiyuan: TongyongHuiyuan,
    tongyong_jiantou_you: TongyongJiantouYou,
    tongyong_fujian: TongyongFujian,
    tongyong_chenggong_mian: TongyongChenggongMian,
    tongyong_wenjianjia2: TongyongWenjianjia2,
    tongyong_shouqi: TongyongShouqi,
    tongyong_huifuquanbu: TongyongHuifuquanbu,
    contact_right: ContactRight,
    contact_left: ContactLeft,
};
const IconCard = (props) => {
    const Icon = iconMap[props.type] || iconMap.other;
    return React.createElement(Icon, Object.assign({}, props));
};
export default IconCard;
